var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{on:{"click":_vm.link}},[_vm._v("link")]),_c('el-button',{attrs:{"disabled":!_vm.isConnected},on:{"click":_vm.occupy}},[_vm._v("occupy")]),_c('el-button',{on:{"click":_vm.leave}},[_vm._v("exit")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }